import {getOwnersByProjectLogic} from "./Owners.logic";
import {
  saveListOwnersByProject,
  saveCountOwnersByProject,
  saveSelectedProject,
} from "../Infrastructure/Owners.store";

export async function getOwnersByProject(id) {
  const {resources: project, count} = await getOwnersByProjectLogic(id);
  saveListOwnersByProject(project);
  saveCountOwnersByProject(count);
}

export async function getSelectedProject(projectId) {
  const project = await saveSelectedProject(projectId);
  return project;
}
